import { resolveUpdate } from './resolve';

export const createProjectsSlice = (set) => ({
  expandedPhases: {}, // { [phaseId]: true }
  setExpandedPhases: (suivant) =>
    set((etat) => ({ expandedPhases: resolveUpdate(suivant, etat.expandedPhases) })),
  phaseTab: {}, // { [phaseId]: 'general' | 'detail' | 'finance' | 'facturation' }
  setPhaseTab: (suivant) => set((etat) => ({ phaseTab: resolveUpdate(suivant, etat.phaseTab) })),
  // Facturation au réel : jours par personne sur une plage choisie librement, indépendante des // { [phaseId]: { [date]: { [devId]: heures } } }
  // dates de la phase (contrairement à Financier/Marge) — un encart Global par client, un par phase.
  dailyHoursByPhase: {},
  setDailyHoursByPhase: (suivant) =>
    set((etat) => ({ dailyHoursByPhase: resolveUpdate(suivant, etat.dailyHoursByPhase) })),
  globalBillingRange: {}, // { [clientId]: { from, to, view:'cards'|'grid' } }
  setGlobalBillingRange: (suivant) =>
    set((etat) => ({ globalBillingRange: resolveUpdate(suivant, etat.globalBillingRange) })),
  phaseBillingRange: {}, // { [phaseId]: { from, to } }
  setPhaseBillingRange: (suivant) =>
    set((etat) => ({ phaseBillingRange: resolveUpdate(suivant, etat.phaseBillingRange) })),
  // Alerte de fin de phase (liste des projets) : heures saisies après la fin, détail par phase et
  // fenêtre « Prolonger la phase ».
  lateHoursByPhase: {}, // { [phaseId]: { heures, derniereDate } }
  setLateHoursByPhase: (suivant) =>
    set((etat) => ({ lateHoursByPhase: resolveUpdate(suivant, etat.lateHoursByPhase) })),
  lateDetails: {}, // { [phaseId]: { loading, lines, worklogs, domain, error, jiraError } }
  setLateDetails: (suivant) =>
    set((etat) => ({ lateDetails: resolveUpdate(suivant, etat.lateDetails) })),
  lateDetailsOpen: null, // phaseId dont le détail des heures est déplié
  setLateDetailsOpen: (suivant) =>
    set((etat) => ({ lateDetailsOpen: resolveUpdate(suivant, etat.lateDetailsOpen) })),
  phaseEndDialog: null, // { clientId, phaseId }
  setPhaseEndDialog: (suivant) =>
    set((etat) => ({ phaseEndDialog: resolveUpdate(suivant, etat.phaseEndDialog) })),
  selectedClient: null, // clientId sélectionné → vue détail
  setSelectedClient: (suivant) =>
    set((etat) => ({ selectedClient: resolveUpdate(suivant, etat.selectedClient) })),
  projectsTab: 'actifs', // 'actifs' | 'archives'
  setProjectsTab: (suivant) =>
    set((etat) => ({ projectsTab: resolveUpdate(suivant, etat.projectsTab) })),
});
